import React from "react";

const MahValidateFields = ({ validateFields, isSubmit }) => {
  return (
    <div className="submit-errors">
      {isSubmit &&
        !(
          validateFields().select_distributor_tab_1.isValid &&
          validateFields().select_distributor_email_1.isValid
        ) && <p className="red-text">MAH is not selected on Cycle 1</p>}
      {isSubmit &&
        !(
          validateFields().select_distributor_tab_2.isValid &&
          validateFields().select_distributor_email_2.isValid
        ) && <p className="red-text">MAH is not selected on Cycle 2</p>}
      {isSubmit &&
        !(
          validateFields().select_distributor_tab_3.isValid &&
          validateFields().select_distributor_email_3.isValid
        ) && <p className="red-text">MAH is not selected on Cycle 3</p>}
    </div>
  );
};

export default MahValidateFields;
